// @flow
import React from "react";
import {Table} from "antd";
import moment from "moment";
import {useTranslation} from "react-i18next";
import {EmptyMessage} from "../../_defaultComponents/EmptyMessage/EmptyMessage";
import {isArray} from "lodash";

const {Column} = Table;

export const LogTable = ({loading, data}) => {
    const {t, i18n} = useTranslation(["courierLogTable"]);

    return (
        <Table
            loading={loading}
            dataSource={isArray(data) ? data : []}
            rowKey="_id"
            data-testid="logTable"
            locale={{emptyText: <EmptyMessage />}}
        >
            <Column
                title={t("fields.username", {ns: "common"})}
                dataIndex="userName"
                render={text => <span data-testid="userName">{text}</span>}
            ></Column>
            <Column
                title={t("fields.userEmail", {ns: "courierLogTable"})}
                dataIndex="userEmail"
                render={text => <span data-testid="userEmail">{text}</span>}
            ></Column>
            <Column
                title={t("fields.company", {ns: "common"})}
                dataIndex="dedicatedCompany"
                render={text => (
                    <span data-testid="dedicatedCompany">
                        {text && text.length > 0 ? text : t("filters.pool", {ns: "common"})}
                    </span>
                )}
            ></Column>
            <Column
                title={t("fields.subcompany", {ns: "common"})}
                dataIndex="dedicatedSubCompanies"
                render={text => <span data-testid="dedicatedSubCompanies">{text.join(", ")}</span>}
            ></Column>

            <Column
                title={t("fields.region", {ns: "common"})}
                dataIndex="regions"
                render={text => (
                    <span data-testid="regions">
                        {text.length > 0 ? text.join(", ") : t("filters.all", {ns: "common"})}
                    </span>
                )}
            ></Column>

            <Column
                title={t("fields.date", {ns: "common"})}
                dataIndex="timestamp"
                sorter={(a, b) => moment(a.timestamp).unix() - moment(b.timestamp).unix()}
                render={text => (
                    <span data-testid="timestamp">
                        {moment(text)
                            .locale(i18n.resolvedLanguage || "tr")
                            .format("lll")}
                    </span>
                )}
            ></Column>
        </Table>
    );
};
